import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { useTheme } from 'foundations-theming/utils';
import ReducedSkeletonThumbnail from './ReducedSkeletonThumbnail';
import { SkeletonBlock, SkeletonWrapper } from '../../../Skeleton';
import { REDUCED_CARD_THUMBNAIL_SIZES } from '../ReducedCardTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ReducedCardSkeleton = ({
  size = 'small',
  use
}) => {
  const theme = useTheme();
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    "data-test-id": "skeleton",
    children: [/*#__PURE__*/_jsx(SkeletonWrapper, {
      borderRadius: theme.borderRadius['100'],
      height: `${REDUCED_CARD_THUMBNAIL_SIZES[size]}px`,
      shimmerColor: use === 'on-dark' ? theme.color['do-not-use-obsidian'] : undefined,
      children: /*#__PURE__*/_jsx(ReducedSkeletonThumbnail, {
        backgroundColor: use === 'on-dark' ? theme.color['do-not-use-pantera'] : undefined,
        size: size
      })
    }), /*#__PURE__*/_jsxs(View, {
      as: "div",
      marginInlineStart: "400",
      children: [/*#__PURE__*/_jsx(SkeletonWrapper, {
        shimmerColor: use === 'on-dark' ? theme.color['do-not-use-obsidian'] : undefined,
        children: /*#__PURE__*/_jsx(SkeletonBlock, {
          color: use === 'on-dark' ? 'do-not-use-pantera' : undefined,
          height: theme.space['400'],
          width: "230px"
        })
      }), /*#__PURE__*/_jsx(View, {
        marginBlockStart: "300",
        children: /*#__PURE__*/_jsx(SkeletonWrapper, {
          shimmerColor: use === 'on-dark' ? theme.color['do-not-use-obsidian'] : undefined,
          children: /*#__PURE__*/_jsx(SkeletonBlock, {
            color: use === 'on-dark' ? 'do-not-use-pantera' : undefined,
            height: "14px",
            width: "180px"
          })
        })
      })]
    })]
  });
};
export default ReducedCardSkeleton;